import {
  ICreateTelehealthSessionRequest,
  ICreateTelehealthSessionResponse,
  IGetTelehealthSessionResponse,
  IPublicTelehealthJoinResponse,
  ITelehealthAssignableProvidersResponse,
  ITelehealthAssignableTechniciansResponse,
  ITelehealthContactInfoResponse,
  ITelehealthDashboardRequest,
  ITelehealthDashboardResponse,
  ITelehealthLink,
  ITelehealthRepository,
  ITelehealthService,
  ITelehealthSmsOutcomesResponse,
  ITelehealthTokenResponse,
  ITelehealthVisitSessionMapResponse,
  IUpdateTelehealthSessionRequest,
} from "../ports/Telehealth";

export const TelehealthServiceImplFactory = ({
  telehealthRepository,
}: {
  telehealthRepository: ITelehealthRepository;
}): ITelehealthService => ({
  createSession(
    request: ICreateTelehealthSessionRequest
  ): Promise<ICreateTelehealthSessionResponse> {
    return telehealthRepository.createSession(request);
  },
  updateSession(
    telehealthSessionId: string,
    request: IUpdateTelehealthSessionRequest
  ): Promise<ICreateTelehealthSessionResponse> {
    return telehealthRepository.updateSession(telehealthSessionId, request);
  },
  getSessionByVisitNote(
    visitNoteId: number
  ): Promise<IGetTelehealthSessionResponse> {
    return telehealthRepository.getSessionByVisitNote(visitNoteId);
  },
  getSessionSmsOutcomes(
    telehealthSessionId: string,
    limit?: number
  ): Promise<ITelehealthSmsOutcomesResponse> {
    return telehealthRepository.getSessionSmsOutcomes(
      telehealthSessionId,
      limit
    );
  },
  listDashboardSessions(
    clinicId: number,
    request?: ITelehealthDashboardRequest
  ): Promise<ITelehealthDashboardResponse> {
    return telehealthRepository.listDashboardSessions(clinicId, request);
  },
  listAssignableProviders(
    clinicId: number
  ): Promise<ITelehealthAssignableProvidersResponse> {
    return telehealthRepository.listAssignableProviders(clinicId);
  },
  listAssignableTechnicians(
    clinicId: number
  ): Promise<ITelehealthAssignableTechniciansResponse> {
    return telehealthRepository.listAssignableTechnicians(clinicId);
  },
  getActiveSessionsByVisitNotes(
    clinicId: number,
    visitNoteIds: number[]
  ): Promise<ITelehealthVisitSessionMapResponse> {
    return telehealthRepository.getActiveSessionsByVisitNotes(
      clinicId,
      visitNoteIds
    );
  },
  getLatestPatientContact(
    patientId: number
  ): Promise<ITelehealthContactInfoResponse> {
    return telehealthRepository.getLatestPatientContact(patientId);
  },
  getClinicianToken(
    telehealthSessionId: string
  ): Promise<ITelehealthTokenResponse> {
    return telehealthRepository.getClinicianToken(telehealthSessionId);
  },
  getOrRotateLink(
    telehealthSessionId: string,
    rotate?: boolean
  ): Promise<ITelehealthLink> {
    return telehealthRepository.getOrRotateLink(telehealthSessionId, rotate);
  },
  shareLink(
    telehealthSessionId: string,
    request: IUpdateTelehealthSessionRequest
  ): Promise<ICreateTelehealthSessionResponse> {
    return telehealthRepository.shareLink(telehealthSessionId, request);
  },
  revokeLink(telehealthSessionId: string): Promise<{ success: boolean }> {
    return telehealthRepository.revokeLink(telehealthSessionId);
  },
  endSession(telehealthSessionId: string): Promise<{ success: boolean }> {
    return telehealthRepository.endSession(telehealthSessionId);
  },
  getPublicJoin(token: string): Promise<IPublicTelehealthJoinResponse> {
    return telehealthRepository.getPublicJoin(token);
  },
  getPublicPatientToken(token: string): Promise<ITelehealthTokenResponse> {
    return telehealthRepository.getPublicPatientToken(token);
  },
  publicPatientLeave(
    token: string,
    participantIdentity: string
  ): Promise<{ success: boolean }> {
    return telehealthRepository.publicPatientLeave(token, participantIdentity);
  },
});
